﻿import { Component, OnInit, ViewChild } from '@angular/core';
import { ShipStatusEnum } from 'src/app/enums/ship-status-enum';
import { ComboDto } from 'src/app/dtos/combo-dto';
import { ShipTypeEnum } from 'src/app/enums/ship-type-enum';
import { Vehicle } from 'src/app/Models/vehicle';
import { AddressControlComponent } from 'src/app/shared/address-control/address-control.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ShipDataDto } from 'src/app/dtos/ship-data-dto';
import { ApiService } from 'src/app/core/services/api.service';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { MatChipInputEvent, MatDialog, MatDialogConfig } from '@angular/material';
import { Location } from '@angular/common';
import { MessageService } from 'src/app/core/services/message.service';
import { ActivatedRoute } from '@angular/router';
import { LoadDto } from 'src/app/dtos/load-dto';
import { Justification } from 'src/app/Models/justification';
import { DialogShowJustificationsComponent } from 'src/app/components/dialogs/dialog-show-justifications/dialog-show-justifications.component';

@Component({
    selector: 'ships-add',
    templateUrl: './ships-add.component.html',
    styleUrls: ['./ships-add.component.scss']
})

export class ShipsAddComponent implements OnInit{
    
    @ViewChild("addressControl") addressControl: AddressControlComponent;
    submitButtonText: string = 'GENERAL.LABELS.CREATE';
    form: FormGroup;
    submitted: boolean;
    id: any;
    ship: ShipDataDto;
    isEditing: boolean;
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    items: string[] = [];

    ShipStatusEnum = ShipStatusEnum;
    ShipTypeEnum = ShipTypeEnum;
    statusList: Array<ComboDto> = new Array();
    typesList: Array<ComboDto> = new Array();
    vehicles: Vehicle[] = [];
    selectedVehicle: Vehicle;
    
    loads: LoadDto[] = [];

    deliveryDate: Date = new Date();
    
    constructor(private activatedRoute: ActivatedRoute, private apiService: ApiService, private formBuilder: FormBuilder,
        private messageService: MessageService, private location: Location, private dialog: MatDialog) {
            this.id = this.activatedRoute.snapshot.params['id'];
        
    }

    ngOnInit(): void {
        this.getStatus();
        this.getTypes();
        this.getVehicles();
        this.getLoads();

        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            firstLastName: ['', Validators.required],
            secondLastName: [''],
            guideNumber: ['', Validators.required],
            status: ['', Validators.required],
            shipType: ['', Validators.required],
            telephone: ['', [Validators.required, Validators.minLength(6)]],
            email: ['', [Validators.required, Validators.email]],
            active: [''],
            replenishment: [''],
            loadId: ['', [Validators.required]]
          });

          if (this.id) {
            this.isEditing = true;
            this.submitButtonText = 'GENERAL.LABELS.EDIT';
      
            this.apiService.get('api/ship/dto/' + this.id).subscribe((data: any) => {
              this.ship = data.data;
              this.form = this.formBuilder.group({
                name: [this.ship.name, Validators.required],
                firstLastName: [this.ship.firstLastName, Validators.required],
                secondLastName: [this.ship.secondLastName],
                guideNumber: [this.ship.guideNumber, Validators.required],
                status: [this.ship.status, Validators.required],
                shipType: [this.ship.shipType, Validators.required],
                telephone: [this.ship.telephone, [Validators.required, Validators.minLength(6)]],
                email: [this.ship.email, [Validators.required, Validators.email]],
                active: [this.ship.active],
                replenishment: [this.ship.replenishment],
                loadId: [this.ship.loadId, [Validators.required]]
              });
              this.addressControl.setAddressData(this.ship);
              this.addressControl.setLatLong(this.ship.lat, this.ship.long);
              this.items = this.ship.items;
              this.selectedVehicle = this.ship.vehicle;
              this.deliveryDate = new Date(this.ship.deliveryDate);
            });
      
          }
      
    }


    getStatus() {
        for (let e in ShipStatusEnum) {
          if (typeof this.ShipStatusEnum[e] === 'string') {
            this.statusList.push(new ComboDto(+e, 'GENERAL.ENUMS.SHIP_STATUS.' + this.ShipStatusEnum[e]));
          }
        }
      }

      getLoads(){
          this.apiService.get('api/load/getLoadsDto').subscribe(response => {
                if(response){
                    this.loads = this.loads.concat(response);
                }
          });
      }

      getTypes() {
        for (let e in ShipTypeEnum) {
          if (typeof this.ShipTypeEnum[e] === 'string') {
            this.typesList.push(new ComboDto(+e, 'GENERAL.ENUMS.SHIP_TYPE.' + this.ShipTypeEnum[e]));
          }
        }
      }

      getVehicles() {
        this.apiService.get('api/vehicle/findAll').subscribe((response: any) => {
          if (response.data) {
            this.vehicles = response.data;
            if(this.ship && this.ship.vehicle)
                this.selectedVehicle = this.ship.vehicle;
          }
        });
      }

      removeItem(item: string): void {
        const index = this.items.indexOf(item);
        if (index >= 0) {
          this.items.splice(index, 1);
        }
      }

      addItem(event: MatChipInputEvent): void {
          const input = event.input;
          const value = event.value;
          if ((value || '').trim()) {
            this.items.push(value.trim());
          }
          if (input) {
            input.value = '';
          }
      }

      back() {
        this.location.back();
      }
    
      onSubmit() {
        this.submitted = true;
        let addressControlData = this.addressControl.getAddressData();
        if (this.form.invalid || addressControlData.isInvalid) {
          return;
        }
        if(!this.selectedVehicle){
            this.messageService.error('Error', 'Debes seleccionar un vehiculo');
            return;
        }

        let ship: ShipDataDto = this.form.value as ShipDataDto;
        let address: ShipDataDto = addressControlData.values as ShipDataDto;
    
        let model = Object.assign({}, ship, address);
        model.vehicle = this.selectedVehicle;
        model.items = this.items;
        model.deliveryDate = new Date(this.deliveryDate);
    
        if (!model.intNumber)
          model.intNumber = 0;
        

        if (this.isEditing) {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = true;
            dialogConfig.autoFocus = false;
            let dialogRef = this.dialog.open(DialogShowJustificationsComponent, dialogConfig);
            dialogRef.afterClosed().subscribe((data: Justification) => {
              if (data) {
                model.justification = data.description;
                model.id = this.id;
                this.apiService.put('api/ship/updateFromDto', model).subscribe((response: any) => {
                  this.messageService.success("Exito", "SHIPC.MESSAGES.SUCCESS");
                  this.location.back();
                });
              }
            });
        }
        else {
          this.apiService.post('api/ship/saveFromDto', model).subscribe((response: any) => {
            this.messageService.success("Exito", "SHIPC.MESSAGES.SUCCESS");
            this.location.back();
          });
        }
      }
}